export enum DOWNLOAD_STATE {
  IDLE = 'idle',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAIL = 'fail',
}
